import { render, staticRenderFns } from "./ApplyDelete.vue?vue&type=template&id=2893fc8c&scoped=true"
import script from "./ApplyDelete.vue?vue&type=script&lang=ts"
export * from "./ApplyDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893fc8c",
  null
  
)

export default component.exports